import React from "react";
import NFLookupEmptyForms from "../../../../Shared/NewForms/NFLookupEmptyForms";

function GoodsRegardingsGenericSkeleton() {
  return (
    <>
      <NFLookupEmptyForms />
    </>
  );
}

export default GoodsRegardingsGenericSkeleton;
